import SearchStore from 'stores/SearchStore';

const visibleStates = [
  'metadata_only',
  'ready',
  'transcribing',
  'transcription_timeout',
  'transcription_error',
  'transcribed',
  'reanalyze',
  'analyzing',
  'analyzer_error',
  'analyzed',
  'summarizing',
  'summarizer_error',
  'complete',
];

/**
 * Very rarely - we may surface a "non-ready" call to the UI due to the livecoaching flow.
 * Provide a whitelist of visible states and filter out results that shouldn't be visible yet.
 *
 * @param result
 * @return {boolean}
 */
export function isInVisibleState(result) {
  if (!result.state) {
    return false;
  }

  return visibleStates.includes(result.state.toLowerCase());
}

export const getCallsSearchResults = (searchStore: any = SearchStore) => {
  return searchStore
    .getState()
    .get('searchResults')
    .results.filter(r => isInVisibleState(r));
};

export const getCallsSearchResultsCount = () => {
  return (SearchStore as any).getState().get('searchTotal');
};
